import { useMemo, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { ReleaseNotesService } from 'src/api/v2';
import { RELEASE_NOTES } from 'src/constants/hook-keys';

const useReleaseNotes = () => {
  const [releaseNotesService] = useState(new ReleaseNotesService());
  const queryClient = useQueryClient();

  const { data, ...rest } = useQuery({
    queryKey: [RELEASE_NOTES],
    queryFn: () => releaseNotesService.getList(),
  });

  const likeMutation = useMutation({
    mutationFn: ({ id, likes }: { id: string; likes: boolean }) => releaseNotesService.like(id, likes),
    onSuccess: () => queryClient.invalidateQueries([RELEASE_NOTES]),
  });

  const sortedNotes = useMemo(() => {
    if (!data) return [];
    return data.sort((a, b) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime());
  }, [data]);

  return {
    releaseNotes: sortedNotes,
    likeMutation,
    ...rest,
  };
};

export default useReleaseNotes;
